const PetelnaMass=[
    {
        id:1,
        title:"пательня з морепродуктами 300г",
        price:"350 грн",
        src:require('../img/skovormore.png'),
        text:"кальмар, мідії, креветка, соєвий соус, сметана, цибуля, часник",
    allergy: `🦑 кальмар,🦪 мідії, 🦐креветки,🌱 соя , 🥛 молоко (сметана)`
    },
    {
        id:2,
        title:"пательня з кальмарами 200г",
        price:"299 грн",
        src:require('../img/skovorkalmar.png'),
        text:"кальмар, перець болгарський, часник, соєвий соус",
    allergy: `🦑 кальмар,🌱 соя`
    },
    {
        id:3,
        title:"пательня з мідіями 200г",
        price:"260 грн",
        src:require('../img/skovormidii.png'),
        text:"мідії, перець болгарський, часник, соєвий соус",
    allergy: `🦪 мідії,🌱 соя`
    },
    {
        id:4,
        title:"пательня з картоплею, куркою та грибами 320г",
        price:"265 грн",
        src:require('../img/skovmush.webp'),
        text:"картопля, гомілка куряча, печериці, сметана, сир гауда, зелень",
    allergy: `🍄‍🟫 гриби,🥛 молоко (сметана, гауда)`
    },
    {
        id:5,
        title:"пательня з картоплею та свининою 320г",
        price:"265 грн",
        src:require('../img/skovpig.webp'),
        text:"картопля, свинина, цибуля ріпчаста, сметана, сир гауда, зелень, томат",
    allergy: `🥛 молоко (сметана, гауда)`
    },
    {
        id:6,
        title:"пательня з картоплею та мисливськими ковбасками 320г",
        price:"265 грн",
        src:require('../img/skovkovb.webp'),
        text:"картопля, ковбаски мисливські, цибуля ріпчаста, перець болгарський, соєвий соус, зелень, часник",
    allergy: `🌱 соя (соєвий соус)`
    },
    
    
]

export default PetelnaMass;